import {
  CloseButton,
  ListContext,
  ListContextValue,
  Stack,
  Typography,
  ValidationErrors,
  newToast,
} from "@compass/core";
import { SubmitButton } from "components";
import { DataCenterFile } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { dataCenterFileViewPageRoute } from "../DataCenterFileViewPage/DataCenterFileViewPage";

export const DataCenterFilePageHeader = (props: {
  handle: string;
  dataCenterFile: DataCenterFile;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = (dataCenterFile: DataCenterFile) => {
    props.setValidationErrors({});

    ApiService.dataCenterFiles
      .saveCreate(dataCenterFile)
      .then((response) => {
        const id = response;
        navigate(`../${dataCenterFileViewPageRoute.getPath({ id: id, crudMode: "view" })}`);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">New {props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton onClick={() => save(props.dataCenterFile)} />
      </Stack>
    </Stack>
  );
};
